<template>
    <section>
      <div class="container" v-if="addOns.appMenu">
        <div class="hero is-bold">
          <div class="hero-body" style="padding-left: 0px; padding-top: 0px">
            <div class="container">
              <h1 class="title" style="color:#3e8ed0">App menu</h1>
              <h4 class="subtitle">Manage your app menu here.</h4>
            </div>
          </div>
        </div>

        <div class="columns is-multiline is-mobile">
          <div class="column is-4 is-offset-1 box" border-width="thick" v-for="index in cardsArray" :key="index">
            <div class="level" >
              <div class="level-left">
              <div style="font-size:17.5px;color:#3e8ed0;cursor:pointer" class="level-item" @click="editAppMenuItem(index)"><b>App menu item {{ index + 1 }}</b></div>
              </div>
              <div class="level-right">
                <div class="level-item">
                  <b-button icon-left="edit" class="button is-info" @click="editAppMenuItem(index)"
                  >Edit</b-button>
                </div>
              </div>
            </div>
            <p v-if="appMenu && appMenu.items[index] !== undefined"><b>{{ appMenu.items[index].appItemTitle }}</b></p>
            <p v-if="appMenu && appMenu.items[index] !== undefined">{{ getAppMenuItemTypeName(appMenu.items[index].type) }}</p>
          </div>
        <div></div>
        </div>
      </div>
    </section>
  </template>
<script>
import AppMenuItemEdit from './AppMenuItemEdit.vue'

export default {
  name: 'AppMenu',
  data: () => {
    return {
      cardsArray: [0, 1, 2, 3, 4, 5]
    }
  },
  computed: {
    appMenu () {
      return this.$store.state.appMenu
    },
    addOns () {
      return this.$store.state.addOns
    },
    role () {
      return this.$store.state.role
    },
    workspaceId () {
      return this.$store.state.workspaceId
    },
    userId () {
      return this.$store.state.uid
    }
  },
  methods: {
    editAppMenuItem (index) {
      let appMenuItemData = null
      if (this.appMenu) {
        if (this.appMenu.items[index] !== undefined) {
          appMenuItemData = this.appMenu.items[index]
        }
      }
      this.$buefy.modal.open({
        parent: this,
        component: AppMenuItemEdit,
        props: { propId: index, propAppMenuItemData: appMenuItemData },
        hasModalCard: true,
        trapFocus: true,
        canCancel: ['x']
      })
    },
    getAppMenuItemTypeName (appMenuItemType) {
      switch (appMenuItemType) {
        case 'questionnaire':
          return 'Questionnaire'
        case 'doubleWeb':
          return 'Double web'
        case 'pdf':
          return 'Documents'
        case 'singleQR':
          return 'Single QR'
        case 'doubleQR':
          return 'Double QR'
        case 'mosaic':
          return 'Mosaic'
        default:
          return ''
      }
    }
  }
}
</script>

<style scoped>
  .box {
    border: 0.5px solid rgb(212, 212, 212);
  }
</style>



// WEBPACK FOOTER //
// src/components/appmenu/AppMenu.vue